<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" :model="vrInfo" :rules="rules" label-width="140px">
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          
          <el-row>
            <el-col :span="24">
              <el-form-item label="隔离方式：" prop="quarantineWay">
                <el-radio v-model="vrInfo.quarantineWay" :label="1">自我隔离</el-radio>
                <el-radio v-model="vrInfo.quarantineWay" :label="2">强制隔离</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="开始隔离时间：" prop="quarantineStartTime">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.quarantineStartTime"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="16">
              <el-form-item label="隔离天数：" prop="quarantineDays">
                <el-input v-model.number="vrInfo.quarantineDays" placeholder="请填写隔离天数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="16">
              <el-form-item label="监管负责人：" prop="quarantinePerson">
                <el-input v-model.trim="vrInfo.quarantinePerson" placeholder="请填写监管负责人"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row >
        <el-col >
          <el-form-item label="情况描述：" prop="quarantineDescription">
            <el-input type="textarea" v-model.trim="vrInfo.quarantineDescription" placeholder="请在此填写隔离详情，比如隔离地点，目前状态等"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
          
        </el-col>
      </el-row>

      
    </el-form>

    <div class="text-right" style="margin-top: 20px;">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="success" @click="submit" size="small" :loading="submitLoading">确认</el-button>
    </div>
  </div>
</template>

<script>
import * as global from "../../config/mUtils";
import * as getData from "../../service/getData";
export default {
  data() {
    var checkNumber = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入隔离天数"));
      }
      if (value >=0 && value <= 99) {
        callback();
      } else {
        return callback(new Error("请输入0-99"));
      }
    };

    return {
      vrInfo: {
        quarantineWay: 1,
        quarantineStartTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        quarantineDays:"",
        quarantinePerson:'',
        quarantineDescription:'',
        quarantineBaseId:''
      },
      rules: {
        quarantineWay: [
          { required: true, message: "请选择隔离方式", trigger: ["blur", "change"] }
        ],
        quarantineStartTime: [
          { required: true, message: "请选择隔离开始时间", trigger: ["blur", "change"] }
        ],
        quarantineDays: [
          {
            required: true,
            // pattern: global.number,
            type:'number',
            message: "隔离天数格式错误",
            trigger: ["blur", "change"],
            transform: value => Number(value)
          },
          { validator: checkNumber, trigger: ["blur", "change"] }
        ],
        quarantineDescription: [
          { max: 200, message: "长度在 200 个字符内", trigger: "blur" }
        ],
        
      },
      submitLoading: false,
      companyList: [],
      quarantineList:null,
      quarantine:null,
    };
  },
  created() {},
  mounted() {
    console.log(this.baseId)
    this.init();
  },
  props: ["id","baseId"],
  computed: {},
  methods: {
    timeFormat(time) {
      return global.toDateTime(time);
    },
    close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    init() {
      getData.isIsolationRegister(this.baseId).then(res=>{
      if (res.data.code != 'success') {
            this.$message.error(res.data.message);
            return;
          }
      let data=res.data.data
      this.quarantine=data.quarantine
      if(this.quarantine!=null){
        
        this.getQuarantine(this.quarantine.quarantineId)
      }
      
    }).catch(_ => {
          console.log(_);
        });
        
    },

    getQuarantine(id){
      getData.getQuarantine(id).then(res=>{
        let data=res.data.data.quarantine
        this.quarantineList=data
        if(data!=null){
          this.vrInfo.quarantineWay=data.quarantineWay
        this.vrInfo.quarantineStartTime=data.quarantineStartTime
        this.vrInfo.quarantineDays=data.quarantineDays
        this.vrInfo.quarantinePerson=data.quarantinePerson
        this.vrInfo.quarantineDescription=data.quarantineDescription
        this.vrInfo.quarantineId=data.quarantineId
        }
      }).catch(_=>{
        console.log(_)
      })
    },
    
    submit() {
      this.$refs["info"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          
          if (this.quarantineList!=null) {
            this.vrInfo.quarantineBaseId=this.baseId
            // console.log(this.vrInfo.quarantineBaseId)
            getData
              .updateQuarantine(this.vrInfo.quarantineId,this.vrInfo.quarantineWay,this.vrInfo.quarantineStartTime,this.vrInfo.quarantineDays,this.vrInfo.quarantinePerson,this.vrInfo.quarantineDescription,this.vrInfo.quarantineBaseId)
              .then(res => {
                this.submitLoading = false;
                if (res.data.code != "success") {
                  this.$message({
                    type: "error",
                    message: res.data.message || res.data.msg
                  });
                  return;
                }
                this.$message.success("更新成功！");
                this.close(1);
              })
              .catch(_ => {
                console.log(_);
                this.submitLoading = false;
              });
          } else {
            this.vrInfo.quarantineBaseId=this.baseId
            console.log(this.vrInfo.quarantineBaseId)
            getData
              .addQuarantine(this.vrInfo.quarantineWay,this.vrInfo.quarantineStartTime,this.vrInfo.quarantineDays,this.vrInfo.quarantinePerson,this.vrInfo.quarantineDescription,this.vrInfo.quarantineBaseId)
              .then(res => {
                console.log(res);
                this.submitLoading = false;
                if (res.data.code != "success") {
                  this.$message({
                    type: "error",
                    message: res.data.message || res.data.msg
                  });
                  return;
                }
                this.$message.success("添加成功！");
                this.close(1);
              })
              .catch(_ => {
                console.log(_);
                this.submitLoading = false;
              });
          }
        }
      });
    },
  },
  components: {},
  watch: {}
};
</script>
<style scoped lang="scss">
@import "../../assets/css/mixin";
</style>
<style lang="scss">
.g-assign-item {
  .el-form-item__label {
    padding: 0;
  }
}
.title-label-right {
  float: right;
  color: #169bd5;
}
.g-basic-info {
  .info-item {
    border: 1px dashed #eee;
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 10px;
    &::after {
      content: "";
      zoom: 1;
      display: block;
      clear: both;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  p {
    span {
      color: #666;
      &.red {
        color: #ff0000;
      }
      &.green {
        color: #00ae0d;
      }
    }
  }
}
.font-blod {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/防疫/quarantine-register-add.vue